export function isInArray<T>(element: T, array: readonly T[]): boolean {
  return array.includes(element);
}
